import React, {FC, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// custom
import { EVENT_ACTION_TYPE, IEvent, IEventState } from '../../../common/state/events/event';
import NavbarUser from '../../../components/navbar/Navbar.user';
import EventUserRegisterTable from '../../../components/tables/Event.register.table';
import EventPreview from './preview/Event.preview.user';
import RegTypeModal, { RegTypeFormData } from '../../../components/modals/registration-type/RegTypeModal';
import { GENERAL_INFO_ACTION_TYPE } from '../../../common/state/subscriptions/general_info';

const UserEventView : FC = () => {
    const history = useHistory();
    // states
    const eventList: IEvent[] = useSelector(({event}:{event:IEventState}) => event.list);
    const [isPreview, togglePreview] = useState(false);
    const [isShowModal, toggleModal] = useState(false);
    // actions
    const eventDispatch : (data : {type: EVENT_ACTION_TYPE, payload: any}) => void = useDispatch();
    const generalInfoDispatch: (data: {type: GENERAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers
    function handleEventPreview (event: IEvent) {
        eventDispatch({type: EVENT_ACTION_TYPE.SELECT_EVENT, payload: event});
        generalInfoDispatch({type: GENERAL_INFO_ACTION_TYPE.EVENT_SELECT, payload: {
            'event_title': event.title,
            'event_id': event.id
        }});
        togglePreview(true);
    }

    function handleRegister ({attendee, payment}: RegTypeFormData) {
        if (attendee === 'self') generalInfoDispatch({type: GENERAL_INFO_ACTION_TYPE.REG_TYPE, payload: 'self'});
        else generalInfoDispatch({type: GENERAL_INFO_ACTION_TYPE.REG_TYPE, payload: 'other'});
        if (payment === 'online') history.push({pathname:'/profile/online'});
        else history.push({pathname:'/profile/offline'});
        toggleModal(false);
    }
    

    return <React.Fragment>
        <NavbarUser/>
        <RegTypeModal 
            showModal={isShowModal} 
            onSubmit={handleRegister}             
            onClose={()=>toggleModal(prev => !prev)}/>
        <div
            className="flex flex-col justify-start w-screen h-screen p-4 overflow-y-scroll bg-gray-200 shadow dark:bg-gray-800 lg:py-4 lg:px-16 items-between">
            <h2 className="mb-2 text-2xl font-medium text-gray-700 dark:text-teal-400">Upcoming Events</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300 dartext-base">
                Here are the list of upcoming events. Click on "View Event" to see Event details in order to register. 
                You can register either for yourself or on behalf of another participant.
            </p>            
            <EventUserRegisterTable
                list={eventList}                
                onView={handleEventPreview}/>
            <EventPreview 
                display={isPreview} 
                onRegister={(data: IEvent) => toggleModal(true)}/>
        </div>
    </React.Fragment>
};

export default UserEventView;